import React from 'react';
import {observable, action, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import s from '../s';
import * as util from '../../util';
import {prod_cat} from '../api';

interface ICategoryProps {
    CategoryID: number;
}

@observer
export default class Category extends React.Component<ICategoryProps> {
    @observable category_name: string;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    componentDidMount(): void {
        this.category_name = s.prod.categories.filter(x => x.CategoryID === this.props.CategoryID)[0].CategoryName;
    }

    @action
    save = async (id: number) => {
        const cat = s.prod.categories.filter(x => x.id === id)[0];
        if (!cat) {
            return;
        }

        if (cat.LinkToProductID < 1) {
            s.pcs.category_map_id = cat.id;
            s.pcs.category_selected_no_new_product = cat.id > 0;
            const _w: number = cat.Doc_Width;
            const _h: number = cat.Doc_Height;

            if (_w <= _h) {
                s.pcs.docWidth = _w;
                s.pcs.docHeight = _h;
                s.pcs.is_horizontal = false;
            } else if (_w > _h) {
                s.pcs.docWidth = _w;
                s.pcs.docHeight = _h;
                s.pcs.is_horizontal = true;
            }
            s.prod.IsHorizontal = s.pcs.is_horizontal;
            s.prod.OrientationHorizontal = s.pcs.is_horizontal;
            s.pcs.docWidth2 = s.pcs.docWidth;
            s.pcs.docHeight2 = s.pcs.docHeight;
            if (s.prod.docWidth2 <= 0) {
                s.pcs.docWidth2 = -1;
                s.pcs.docHeight2 = -1;
            }

            if (s.pcs.glass_id === 2) {
                s.pcs.glass_id = 4;
                s.prod.AllowGlassID2 = 0;

            }

            if (s.prod.DYF_FrameStyleID === 2 || s.prod.DYF_FrameStyleID === 7 || s.prod.DYF_FrameStyleID === 8 || s.prod.DYF_FrameStyleID === 6) {
                if (s.pcs.docWidth > 9 && s.pcs.docHeight > 12) {
                    s.pcs.use_plexi = true;
                } else if (s.pcs.docWidth > 12 && s.pcs.docHeight > 9) {
                    s.pcs.use_plexi = true;
                } else {
                    s.pcs.use_plexi = false;
                }
            } else if (s.prod.DYF_FrameStyleID === 3 || s.prod.DYF_FrameStyleID === 5) {
                if (s.pcs.docWidth > 11 && s.pcs.docHeight > 14) {
                    s.pcs.use_plexi = true;
                } else if (s.pcs.docWidth > 14 && s.pcs.docHeight > 11) {
                    s.pcs.use_plexi = true;
                } else {
                    s.pcs.use_plexi = false;
                }
            } else {
                if (s.pcs.docWidth > 14 && s.pcs.docHeight > 18) {
                    s.pcs.use_plexi = true;
                } else if (s.pcs.docWidth > 18 && s.pcs.docHeight > 14) {
                    s.pcs.use_plexi = true;
                } else {
                    s.pcs.use_plexi = false;
                }
            }

            s.ui.doRender = true;
            s.ui.update_pricing = true;
            s.pulse();
        } else {
            const result = (await prod_cat(cat.LinkToProductID)) as string;
            runInAction(async () => {
                util.openLink(result);
            });
        }
    };

    render() {
        if (!s.ready || !this.category_name || s.pcs.is_caf) {
            return;
        }

        return (
            <div
                className="gray-box category-container"
                id={`category-${this.props.CategoryID}`}
            >
                <div>
                    <span
                        className="header-std"
                        style={{paddingRight: '0.25rem'}}
                    >
                        {this.category_name}
                    </span>

                    {s.prod.categories.length < 6 && (
                        <div
                            className="cat-prod"
                            role="listbox"
                            aria-label="Select the option of the product category"
                        >
                            {s.prod.categories
                                .filter(x => x.CategoryID === this.props.CategoryID)
                                .map((m, i) => (
                                    <div
                                        key={i}
                                        title={m.Name}
                                        data-catid={`category-${this.props.CategoryID}`}
                                        aria-label={`Select the ${m.Name} option of the product category ${m.CategoryName}`}
                                        className={`cust-entity${s.pcs.category_map_id === m.id ? ' active' : ''}`}
                                        onClick={() => this.save(m.id)}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                this.save(m.id);
                                            }
                                        }}
                                        role="option"
                                        tabIndex={0}
                                    >
                                        <div className="title">
                                            {m.Name}
                                            {s.__fast_ship_orig && s.isRetail && s.pcs.category_map_id === m.id && (
                                                <div className={`prod-fast-shipping fast-shipping-${s.PortalID}`}>
                                                    <i className={s.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}></i>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    )}

                    {s.prod.categories.length > 5 && (
                        <select
                            className="cust-entity form-select ib"
                            aria-label={`Select ${this.category_name}`}
                            onChange={e => this.save(parseInt(e.target.value, 10))}
                        >
                            {s.prod &&
                                s.prod.linos &&
                                s.prod.categories
                                    .filter(x => x.CategoryID === this.props.CategoryID)
                                    .map((m, i) => (
                                        <option
                                            key={i}
                                            value={m.id}
                                            selected={s.pcs.category_map_id === m.id}
                                        >
                                            {m.Name}
                                        </option>
                                    ))}
                        </select>
                    )}
                </div>
            </div>
        );
    }
}
